<div class="modal-background" (click)="closeModal('cancel')">
  <div [class.loaded]="isLoaded" class="modal-body" [class.confirmation-modal]="data.type === 'confirmation'">
    @if (data.type === 'confirmation') {
    <div class="confirmation-container">
      <div class="flex gap-4">
        <div class="icon-wrapper">

          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6" />
            <path d="m9 15 2 2 4-4" />
          </svg>
        </div>
        <div class="text-content">
          <h2 class="text-gray-800 text-lg font-medium mb-1">{{ data.text }}</h2>
          <p class="text-gray-500 text-sm">Please confirm to proceed with the submission.</p>
        </div>
      </div>
      <div class="flex justify-end gap-3 mt-6">
        <button mat-raised-button (click)="closeModal('cancel')"
          class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors">
          {{ data.cancelText || 'Cancel' }}
        </button>
        <button mat-raised-button class="app-secondary flex flex-row"
          (click)="closeModal('confirm'); $event.stopPropagation()">
          {{ data.confirmText || 'Submit' }}
        </button>
      </div>
    </div>
    }

    @if (data.type === 'error' && data.duration === 0) {
    <div class="message-modal-alert px-5 pt-5 pb-4 bg-white">
      <div class="flex items-start gap-4 mb-4">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-[50px] h-[50px] text-red-500">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="flex-1">
          <h2 class="text-gray-700 text-xl font-semibold mb-2">{{ data.title || 'Error' }}</h2>
          <p class="text-gray-600 text-sm">{{ data.detailMessage || data.text }}</p>
        </div>
      </div>
      <div class="flex justify-end gap-3 pt-2">
        <button type="button"
          class="bg-red-600 text-white rounded-lg hover:bg-red-700 px-5 py-2.5 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors"
          (click)="closeModal('cancel'); $event.stopPropagation()">
          {{ data.confirmText || 'Close' }}
        </button>
      </div>
    </div>
    } @else if (data.type !== 'confirmation') {
    <div class="icon-body flex flex-col justify-center items-center">
      @if (data.type === 'success') {
      <div class="success-animation">
        <div class="success-checkmark">
          <div class="check-icon">
            <span class="icon-line line-tip"></span>
            <span class="icon-line line-long"></span>
            <div class="icon-circle"></div>
            <div class="icon-fix"></div>
          </div>
        </div>
      </div>
      }

      @if (data.type === 'error' || data.type === 'INVALID-CODE' ) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
      </svg>
      }

      @if (data.type === 'warning') {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>

      }



      @if (data.type === 'EXPIRED-CODE' ) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002" />
      </svg>
      }

      @if ( data.type === 'NOT-STARTED') {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>


      }




      @if (data.type === 'delete') {
      <div class="flex flex-row w-full justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
        </svg>
      </div>

      }
      <div *ngIf="data.type === 'loading'">[Loading Icon]</div>
    </div>
    <div class="text-body">
      {{ data.text }}
    </div>
    @if (data.type === 'warning' || data.type === 'delete') {
    <div class="mt-4">
      <button mat-raised-button (click)="closeModal('cancel')"
        class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors mx-2">
        Cancel
      </button>
      <button mat-raised-button (click)="closeModal('confirm'); $event.stopPropagation()"
        class="inline-flex items-center justify-center app-secondary">
        {{ data.confirmText || 'Ok' }}
      </button>
    </div>
    }
    }
  </div>
</div>